exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.users-table__checkbox.custom-checkbox .custom-control-label::before{border:2px solid #20a8d8\n}\n.users-table__checkbox.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:none\n}\n.users-table__checkbox.custom-checkbox .custom-control-input:checked~.custom-control-label::before{background-color:gray\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/t1/Admin/Users.vue
// module id = 1815
// module chunks = 0